<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <el-form class="search" :inline="true" size="mini" :model="search">
          <el-form-item label="姓名" v-if="!clienId">
            <el-input
              v-model="search.customer_name"
              maxlength="30"
              class="w200"
              placeholder="请输入姓名"
              clearable
            />
          </el-form-item>
          <el-form-item label="咨询员工">
            <el-input
              v-model="search.work_name"
              maxlength="30"
              class="w200"
              placeholder="请输入员工姓名"
              clearable
            />
          </el-form-item>
          <el-form-item label="咨询日期">
            <el-date-picker
              v-model="search.start"
              type="date"
              class="w130"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <el-date-picker
              v-model="search.end"
              type="date"
              class="w130"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <div class="btnBox">
        <el-button
          type="primary"
          class="mb10"
          size="mini"
          :disabled="list.length == 0"
          @click="hint('导出数据','')"
        >导出数据</el-button>
        <el-button
          type="primary"
          class="mb10"
          size="mini"
          @click="goVisitClient"
          v-if="clienId"
        >添加咨询</el-button>
      </div>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            @selection-change="handleSelectionChange"
          >
            <ElTableColumn label="客户名称" prop="customer_name" width="100" />
            <ElTableColumn label="手机号" prop="telephone" width="100" />
            <ElTableColumn label="门店名称" prop="shop_name" width="120" />
            <ElTableColumn label="员工名称" prop="consult_name" width="100"/>
             <ElTableColumn
                label="咨询情况"
                prop="consult_content"
                width="200"
              >
                <template #default="scope">
                  <div class="cell-wrap">
                    <div v-if="!scope.row.expandConsult" class="text-single">
                      <span class="ellipsis">
                        {{ scope.row.consult_content }}
                      </span>
                      <div class="arrow-btn" @click="toggleConsult(scope.row)">
                        <i class="el-icon-arrow-down"></i>
                      </div>
                    </div>
                    <div v-else class="text-full">
                      <div class="full-content">{{ scope.row.consult_content }}</div>
                      <div class="arrow-btn" @click="toggleConsult(scope.row)">
                        <i class="el-icon-arrow-up"></i>
                      </div>
                    </div>
                  </div>
                </template>
              </ElTableColumn>
            <ElTableColumn label="潜在需求" prop="latent_demand" />
            <ElTableColumn label="咨询时间" prop="create_time" width="100" />
            <el-table-column label="音频列表" width="500">
              <template slot-scope="scope">
                <div 
                  v-for="(audio, index) in scope.row.audio_list" 
                  :key="index" 
                  class="audio-item"
                >
                  <span>{{ audio.file_name }}</span>
                  <audio controls :src="audio.url"></audio>
                  <el-button
                    type="primary"
                    @click="startSummary(audio)"
                    size="mini"
                    :disabled="audio.task_status == 1 || (audio.task_status == 0 && audio.is_get_gain == 0)"
                  >
                    {{ audio.task_status == -1 
                      ? '生成智能纪要' 
                      : audio.task_status == 1 || (audio.task_status == 0 && audio.is_get_gain == 0) 
                        ? '生成中' 
                        : audio.task_status == 0 && audio.is_get_gain == 1 
                          ? '去查看' 
                          : audio.task_status == 2 
                            ? '重新生成' 
                            : '' 
                    }}
                  </el-button>
                </div>
              </template>
            </el-table-column>

          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <el-dialog title="添加咨询记录" :visible.sync="visitClient" :close-on-click-modal="false">
      <el-form
        ref="detail"
        label-position="right"
        label-width="200px"
        :rules="rules"
        :model="detail"
        class="frame"
      >
        <el-form-item label="客户姓名:">
          <el-input v-model="consignee" class="w300" readonly></el-input>
        </el-form-item>
        <el-form-item label="咨询情况" prop="consult_content">
          <el-input
            v-model="detail.consult_content"
            class="w300"
            placeholder="请填写咨询情况"
            type="textarea"
          />
        </el-form-item>
        <el-form-item label="潜在需求" prop="latent_demand">
          <el-input
            v-model="detail.latent_demand"
            class="w300"
            placeholder="请填写潜在需求"
            type="textarea"
          />
        </el-form-item>

        <el-form-item label="咨询时间:" prop="consult_time">
          <el-date-picker
              v-model="detail.consult_time"
              type="date"
              class="w300"
              placeholder="请选择咨询时间"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
        </el-form-item>

        <div class="footerBtn">
          <el-button type="primary" size="mini" class="mainBtn" @click="submitForm('detail')">完成，提交</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pagination from "@/components/Pagination";
import {
  vistExport,
  returnConsult,
  addConsult,
  createTask,
  getTaskInfo

} from "@/api/client";
class Search {
  customer_name = "";
  work_name="";
  start = "";
  end = "";
}
class Detail {
  customer_id = "";
  consult_content = "";
  consult_time="";
  latent_demand=""
}
class Rules {
  consult_content = [
    { required: true, message: "请填写咨询情况", trigger: "blur" }
  ];

  consult_time = [
    { required: true, message: "请选择咨询时间", trigger: "blur" }
  ];
}
class Page {
  total = 0;
  page = 1;
  pagesize = 10;
}
export default {
  name: "ClientList",
  components: {
    pagination
  },
  props: {
    clienId: {
      type: String,
      default: ""
    },
    consignee: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      page: new Page(),
      search: new Search(),
      detail: new Detail(),
      rules: new Rules(),
      list: [],
      idList: "",
      visitClient: false,
      notHave: false,
      mixTime:{
        disabledDate(time){
          return time.getTime()<Date.now()-8.64e7;
        }
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {

    this.detail.customer_id = this.clienId ? this.clienId : "";
    this.getList();
  },
  methods: {
    toggleConsult(item){
      console.log(item);
      this.$set(item, 'expandConsult', !item.expandConsult);
    },

     startSummary(item) {
      if(item.task_status == 0 && item.is_get_gain == 1 ){
 
        const routeData = this.$router.resolve({
          path: '/client/aIMinutes',
          query: {
            id: item.task_id,
            url: item.url
          }
        })
        window.open(routeData.href, '_blank')
      }else{
        createTask({
            file_url: item.url
          }).then(res => {
            if (res.code != 200) {
              this.$message.error(res.msg);
              return;
            }
            this.getList();
        }).catch(err => {
          this.$message.error("网络请求异常");
        });
      }
    },
    go_vist(item){
      this.visitClient = true;
      console.log(item);
      this.detail.vistId = item.id;
    },
    goVisitClient(){
      this.detail = new Detail();
      this.visitClient = true;
      this.detail.customer_id = this.clienId;
    },
    getList(option) {
      if (option === "search") this.page = new Page();
      returnConsult({
        ...this.page,
        ...this.search,
        customer_id: this.clienId,
        export:0
      }).then(res => {
        this.list = res.data.data;
        if (!this.list.length) {
          this.notHave = true;
        }
        this.page.total = res.data.total;
      });
    },
    // 提交
    submitForm(formName) {
      // this.checking();
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.hint("添加该条咨询记录", "add");
        } else {
          return false;
        }
      });
    },
    // 提示
    hint(text, type) {
      this.$confirm(`${text},是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (type == "add") {
            this.confirm(type);
          } else {
            this.getExport();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 导出
    getExport() {
       returnConsult({
        ...this.search,
        customer_id: this.clienId,
        export:1
      }).then(res => {
         window.open(res.data.url);
      });
    },
    // 确认提交
    confirm(type) {
    this.detail.consult_id = this.userInfo.id
      addConsult({ ...this.detail }).then(res => {
        this.$message({
          type: "success",
          message: res.msg
        });
        this.visitClient = false;
        this.getList();
      });
    },
    // 改变表格选中状态
    handleSelectionChange(val) {
      this.idList = val.map(i => {
        return i.id;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.audio-item{
  display: flex;
  align-items: center;
  gap: 8px;
}
.wrap {
  padding: 20px;
}
.result {
  margin-top: 20px;
}



.mainColor {
  color: #2dc0a3;
}
.content {
  height: calc(100% - 56px);
  overflow-y: auto;
}
.bgW {
  background: #fff;
  border-radius: 3px;
  padding: 10px;
}

.el-form-item {
  margin: 0px 20px 3px 0;
}
.accountCon {
  background: #fff;
  padding: 0px 10px 30px;
  .btnBox {
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }
  .entryBox {
    height: 600px;
    overflow-y: scroll;
    .entryRow1 {
      display: flex;
      .item-circle {
        width:30px;
        height: 30px;
        z-index: 2;
      }
      .clientName {
        line-height: 30px;
        font-size: 16px;
        font-weight: bold;
      }
    }
    .entryRow2 {
      line-height: 12px;
      color: #999;
      margin: 10px 0 0 20px;
      display: flex;
      font-size: 14px;
    }
    .entryRow3 {
      height:40px;
      color: #444;
      margin: 10px 0 20px;
      font-size: 15px;
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
.frame {
  .el-form-item {
    margin: 0px 20px 26px 0;
  }
}
.footerBtn {
  text-align: right;
}
.go_vist{
  font-weight:bold;
  color: red;
  cursor: pointer;
}
.cell-wrap {
  width: 100%;
}
.text-single {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.text-full {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ellipsis {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.full-content {
  white-space: pre-wrap;
  word-break: break-all;
}
.arrow-btn {
  color: #409eff;
  cursor: pointer;
  flex-shrink: 0;
}
//音频增加的样式------begin
.audio-table-wrap {
  padding: 20px;
}
/* 单个音频容器：纵向排列，间距优化 */
.audio-item {
  display: flex;
  align-items: center;
  margin: 6px 0;
}
/* 音频播放器样式：适配表格宽度 */
.audio-player {
  width: 320px;
  height: 34px;
  outline: none;
  margin-right: 10px;
}
.audio-name {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
}
//音频增加的样式------end


</style>
